var map = {
	"./404.md": 665,
	"./_template.jsx": 386,
	"./fi/index.yaml": 666,
	"./fi/varaus.yaml": 667,
	"./se/index.yaml": 668
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 664;



//////////////////
// WEBPACK FOOTER
// . (coffee|cjsx|ts|tsx|jsx|js|md|rmd|mkdn?|mdwn|mdown|markdown|litcoffee|ipynb|html|json|yaml|toml)$
// module id = 664
// module chunks = 0